<template>
  <div class="mx-3 my-3 pb-4">
    <div class="grid grid-cols-12 gap-4">
      <div class="flex flex-col col-span-2" style="cursor: pointer;">
        <div
          :class="currentRoute === 'apikey' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('apikey')"
        >
          <div class="flex">
            <div>API key</div>
          </div>
        </div>
        <div
          :class="currentRoute === 'credentials' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('credentials')"
        >
          <div class="flex">
            <div>Credentials</div>
          </div>
        </div>
      </div>
      <div class="col-span-10">
        <SimpoApiKey v-if="currentRoute === 'apikey'" ref="apiKeyRef" />
        <SimpoCredentials v-if="currentRoute === 'credentials'" ref="credentialsRef" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref } from "vue";
import SimpoApiKey from "./SimpoApiKey.vue";
import SimpoCredentials from "./SimpoCredentials.vue";

type TabChild = { refresh?: () => void } | null;

const currentRoute = ref("apikey");
const apiKeyRef = ref<TabChild>(null);
const credentialsRef = ref<TabChild>(null);

const refreshActiveTab = () => {
  if (currentRoute.value === "apikey") apiKeyRef.value?.refresh?.();
  else if (currentRoute.value === "credentials") credentialsRef.value?.refresh?.();
};

const select = (route: string) => {
  currentRoute.value = route;
  nextTick(() => refreshActiveTab());
};

const refresh = () => {
  refreshActiveTab();
};

defineExpose({ refresh });
</script>
